import { __makeTemplateObject } from "tslib";
import React from 'react';
import styled from 'styled-components';
export var ProgressHeader = function (_a) {
    var steps = _a.steps, activeStep = _a.activeStep;
    var percent = (100 / steps.length) * (activeStep + 1);
    return (React.createElement("div", null,
        React.createElement("div", { className: "d-flex mx-2" },
            React.createElement("h6", { className: "w-50 mb-2" }, steps[activeStep].name),
            React.createElement("h6", { className: "w-50 mb-2 text-right" },
                "Step ",
                activeStep + 1,
                " of ",
                steps.length)),
        React.createElement(ProgressWrapper, null,
            React.createElement("div", { className: "progress-bar bg-success", role: "progressbar", "aria-valuenow": percent, "aria-valuemin": 0, "aria-valuemax": 100, style: { width: percent + "%" } }))));
};
export default ProgressHeader;
var ProgressWrapper = styled.div.attrs(function () { return ({
    className: 'progress progress-stepper mb-2 rounded-0',
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n     &.progress-stepper {\n        height: 4px;\n     }\n"], ["\n     &.progress-stepper {\n        height: 4px;\n     }\n"])));
var templateObject_1;
//# sourceMappingURL=ProgressHeader.js.map


// WEBPACK FOOTER //
// ../../../src/components/stepper/ProgressHeader.tsx